import "./NewsWorkflow.scss";
import NewsEditDialog from "@/components/News/NewsEditDialog/NewsEditDialog.vue";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import {
  destroyFile,
  getMongoFileId,
  getTokenHeader,
  getPrincipalName,
  getThumbnailUrl
} from "@/helpers/commonHelper";
import * as newsHelper from "@/helpers/newsHelper";
let newsHelperVar = { ...newsHelper };
delete newsHelperVar["imports"];
import { imports } from "@/helpers/newsHelper";
import { getFilename, slugifyFilename } from "@/helpers/newsGbXmlHelper";
import axios from "axios";
import InfoDialog from "@/components/Common/InfoDialog/InfoDialog.vue";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "NewsList",
  components: { InfoDialog, NewsEditDialog },
  props: ["update"],
  data() {
    return {
      headers: [
        { text: "Titel", value: "title" },
        {
          text: "Merkmale",
          align: "start",
          value: "feature",
          width: "15%"
        },
        { text: "Import-Datum", value: "create_date" },
        {
          text: "Eingereicht durch",
          value: "source"
        },
        {
          text: "Aktionen",
          value: "actions",
          sortable: false,
          align: "center",
          width: "10%"
        }
      ],
      config: {},
      issues: {},
      features: {},
      featureGroups: {},
      newsUser: [],
      filter: {
        deleted: false,
        declined: false
      },
      editDialog: false,
      editedItem: {},
      previewDialog: false,
      previewData: {},
      defaultItem: {
        alternative_content: {
          web: "",
          gemeindeblatt: ""
        },
        newsDate: "",
        meta_data: {
          keywords: [],
          url_part: ""
        },
        feature_ids: [],
        related_news: [],
        channels: [],
        images: [],
        files: [],
        production_note: "",
        title: "",
        principal_id: this.currentPrincipal,
        creator_id: "",
        change_date: "",
        create_date: "",
        priority: null,
        issue_id: "",
        released: false,
        content: "",
        web_release_date: new Date().toISOString(),
        highlight: false,
        isNew: true,
        _id: ""
      },
      news: [],
      loading: true,
      loadingOverlay: false,
      options: {},
      total: 0,
      mainPeacock: "#00636C",
      mainRed: "#c55c52",
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      statusItem: {},
      isMounted: false,
      newsEmailImportUsersDialog: false
    };
  },
  watch: {
    options() {
      if (this.isMounted) this.loadNews();
    },
    search(val) {
      if (val?.length >= 3) this.loadNews();
      if (val === "") this.loadNews();
    },
    async currentPrincipal() {
      this.filter = {
        deleted: false,
        declined: false
      };
      await this.loadCollections();
      this.loadNews();
    },
    async editDialog(val) {
      if (val) {
        await this.fetchExistingAppPushMessageForNews();
      } else if (this.$refs.newsEditDialog) {
        this.$refs.newsEditDialog.existingAppPushMessage = null;
      }
    }
  },
  computed: {
    currentPrincipal() {
      return this.$store.state?.selectedPrincipal?.id;
    },
    principals() {
      return this.$store.state.principals ?? [{}];
    },
    isAdmin() {
      return (
        this.$store.state.currentUser?.scopes.includes("role:admin") ||
        this.$store.state.currentUser?.scopes.includes("role:news_admin")
      );
    },
    isExternNewsEditor() {
      return this.$store.state.currentUser?.scopes?.includes(
        "role:extern_news_editor"
      );
    },
    previewPrint() {
      return (
        this.previewData?.alternative_content?.gemeindeblatt ||
        this.previewData.content
      );
    },
    previewWeb() {
      return (
        this.previewData?.alternative_content?.web || this.previewData.content
      );
    },
    appdinxLogin() {
      return this.$store.state.selectedPrincipal?.additional_data?.appdinxLogin;
    },
    activeImports() {
      return imports
        .filter(_ => _.isActive(this.$store.state.selectedPrincipal))
        .map(_ => _.typeId);
    },
    newsEmailImport() {
      return this.$store.state.selectedPrincipal?.additional_data
        ?.newsEmailImport;
    },
    users() {
      return this.$store.state.users;
    },
    newsEmailImportUsers() {
      if (!this.newsEmailImport) {
        return [];
      }
      const whiteList = this.newsEmailImport?.receiveFromWhiteList;
      if (!whiteList?.length) {
        return [];
      }
      return whiteList
        .map(userId => this.users.find(user => user._id === userId))
        .filter(Boolean);
    }
  },
  async mounted() {
    const itemsPerPage = this.itemsPerPage;
    this.filter.itemsPerPage = this.filter.limit = itemsPerPage;
    await this.$store.dispatch("getNewsConfig");
    await this.$store.dispatch("getAllUsers");
    await this.$store.dispatch("getThirdPartySystems", { module: "News" });
    await this.loadCollections();
    await this.loadNews();
    //this.update if route is: /anzeigenassistent/news/update/:id
    if (this.update) {
      await this.fetchNews(this.update);
    }
    this.isMounted = true;
  },
  methods: {
    getFilename,
    slugifyFilename,
    getPrincipalName,
    getThumbnailUrl,
    previewImage(item) {
      const url = item?.images?.[0]?.url;
      return this.getThumbnailUrl(url, "news", 70, "-");
    },
    morePictures(item) {
      return item.images.length > 1;
    },
    async loadCollections() {
      await this.loadConfig();
      await this.loadIssues();
      await this.loadFeatures();
      await this.loadFeatureGroups();
      await this.loadAppContentTypes();
      await this.getNewsUser(this.currentPrincipal);
    },

    async getNewsUser(principal) {
      const headers = getTokenHeader();
      if (headers) {
        const response = await axios.get(
          `${env.auth_api_client_url}users/find`,
          {
            params: {
              principal_id: principal
            },
            headers
          }
        );
        let users = response?.data.data ?? [];
        const selectedPrincipal = this.$store.state.selectedPrincipal;
        let principals = [selectedPrincipal?.id];

        if (selectedPrincipal.subPrincipals?.length)
          principals = principal.concat(selectedPrincipal.subPrincipals);

        users = users.filter(user => principals.includes(user.principal_id));

        users?.forEach(user => {
          user.name = `${user.first_name} ${user.last_name}`;
        });
        this.newsUser = users;
      }
    },
    async fetchNews(id) {
      const headers = getTokenHeader();
      const params = {
        principal_id: this.currentPrincipal
      };
      this.$refs.newsEditDialog.loadingStatus(true);
      try {
        const response = await axios.get(
          env.news_api_client_url + "externNews/" + id,
          {
            headers,
            params
          }
        );
        this.editedItem = Object.assign({}, response.data);
        this.$refs.newsEditDialog.fillData(this);
        this.editDialog = true;
      } catch (error) {
        this.close();
        this.createError(error);
      }
      this.$refs.newsEditDialog.loadingStatus(false);
    },
    getNewsSearchParams(pagenation = true) {
      const { page, itemsPerPage } = this.options;

      const params = {
        principal_id: this.currentPrincipal,
        limit: itemsPerPage,
        offset: (page - 1) * itemsPerPage,
        direction: "asc",
        deleted: false,
        declined: false
      };
      if (!pagenation) {
        // WARNING strange service behavior
        // if the limit is higher than the filtered items
        // the entries will be limited to 20
        params.limit = this.total;
        params.offset = 0;
      }
      //filter empty params
      Object.keys(params).forEach(
        key => params[key] === undefined && delete params[key]
      );
      return params;
    },
    async loadNews(pagenation = true) {
      if (!this.config) {
        return;
      }
      this.loading = true;
      const headers = getTokenHeader();
      const params = this.getNewsSearchParams(pagenation);
      try {
        const response = await axios.get(
          env.news_api_client_url + "externNews",
          {
            headers,
            params
          }
        );
        if (!pagenation) {
          // f.e. for export (xml, images, excel)
          this.loading = false;
          // news count changed -> cancel export + ask user to search again
          if (parseInt(response?.headers?.["x-count"]) !== this.total) {
            this.createError({
              text:
                "Bitte erneut suchen. Die Menge der Nachrichten hat sich verändert."
            });
            return [];
          }
          return response.data;
        }
        this.news = response.data;
        let count = response?.headers?.["x-count"];
        if (isNaN(count)) {
          console.error("no number in x-count");
        }
        this.total = parseInt(count);
      } catch (error) {
        this.createError(error);
      }
      this.loading = false;
    },
    async fetchExistingAppPushMessageForNews() {
      if (this.editedItem.isNew || !this.editedItem._id) {
        this.$refs.newsEditDialog.existingAppPushMessage = null;
        return;
      }
      const headers = getTokenHeader();
      const params = {
        principal_id: this.currentPrincipal,
        news_id: this.editedItem._id
      };
      try {
        const res = await axios.get(
          env.news_api_client_url + "app_push_message",
          {
            headers,
            params
          }
        );
        if (res.data?.length) {
          this.$refs.newsEditDialog.existingAppPushMessage = res.data[0];
        } else {
          this.$refs.newsEditDialog.existingAppPushMessage = null;
        }
      } catch (e) {
        this.$refs.newsEditDialog.existingAppPushMessage = null;
        console.error(e);
      }
    },
    async editItem(item) {
      this.editedIndex = this.news.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.isNew = false;
      //prefill cached data
      this.$refs.newsEditDialog.fillData(this);
      this.editDialog = true;
      //refresh data
      this.fetchNews(item._id);
    },
    async deleteNews(item) {
      const params = {
        principal_id: this.currentPrincipal
      };
      const allFiles = item.files.concat(item.images);
      allFiles.asyncForEach(async file => {
        await destroyFile("news", getMongoFileId(file));
      });
      const headers = getTokenHeader();
      await axios.delete(`${env.news_api_client_url}news/${item._id}`, {
        headers,
        params
      });
    },
    async approveItem(item) {
      const isConfirmed = await this.$confirm(
        "Sind Sie sicher, dass Sie diese Nachricht freigeben möchten?",
        confirmWarningConfig
      );

      if (isConfirmed) {
        const headers = getTokenHeader();
        try {
          await axios.get(
            `${env.news_api_client_url}externNews/approve/${item._id}`,
            { headers }
          );
        } catch (err) {
          return await this.createError({
            ...err,
            text: "Nachricht konnte nicht freigegeben werden."
          });
        }
        await Promise.all([
          this.createSuccess("Nachricht erfolgreich freigegeben!"),
          this.loadNews()
        ]);
      }
    },
    async declineItem(item) {
      const isConfirmed = await this.$confirm(
        "Sind Sie sicher, dass Sie diese Nachricht ablehnen möchten?",
        confirmWarningConfig
      );

      if (isConfirmed) {
        const headers = getTokenHeader();
        try {
          await axios.get(
            `${env.news_api_client_url}externNews/decline/${item._id}`,
            { headers }
          );
          await this.deleteNews(item);
        } catch (err) {
          return await this.createError({
            ...err,
            text: "Nachricht konnte nicht abgelehnt werden."
          });
        }
        await Promise.all([
          this.createSuccess("Nachricht erfolgreich abgelehnt!"),
          this.loadNews()
        ]);
      }
    },
    async afterSave(close) {
      if (this.editedIndex > -1) {
        Object.assign(this.news[this.editedIndex], this.editedItem);
      } else {
        this.news.push(this.editedItem);
      }
      await this.loadNews();

      const logOverviewRef = this.$refs.newsEditDialog?.$refs?.logOverview;
      const logsFetched = logOverviewRef?.logsFetched;
      logOverviewRef?.resetLogs();

      if (close) {
        this.close();
      } else if (logsFetched) {
        logOverviewRef?.getLogs().then(null);
      }

      await this.createSuccess("Erfolgreich gespeichert!");
    },
    detachNews(item) {
      this.$confirm(
        `<b>"${item.title}"</b> gehört zu einer geschlossenen Print-Ausgabe.
        Soll eine Kopie erstellt werden um die Nachricht für andere Kanäle (z.B. Web) zu bearbeiten?`,
        confirmWarningConfig
      ).then(async res => {
        if (res) {
          await this.detachNewsRequest(item); //except gemeindeblatt-channel
          this.copyNews({ ...item, channels: ["web"] }, this.isLocked(item));
        }
      });
    },
    async close() {
      if (this.update) {
        this.editDialog = false;
        await this.$router.push("/news/news");
        return;
      }
      this.editDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.$refs.newsEditDialog.fillData(this);
        this.$refs.newsEditDialog?.$refs?.logOverview?.resetLogs();
        this.editedIndex = -1;
      });
    },
    async nextPage() {
      const pages = Math.ceil(this.total / this.itemsPerPage);
      if (this.page < pages) {
        this.page++;
      }
    },
    async previousPage() {
      if (this.page > 1) {
        this.page--;
      }
    },
    async detachNewsRequest(item) {
      item.loading = true;
      try {
        const headers = getTokenHeader();
        await axios.put(
          `${env.news_api_client_url}news/`,
          {
            id: item._id,
            _id: item._id,
            principal_id: item.principal_id,
            channels: ["gemeindeblatt"], //only gemeindeblatt-channel
            meta_data: {
              ...item.meta_data,
              url_part:
                item?.meta_data?.url_part?.split("_")[0] +
                "_" +
                (Date.now() + "").slice(-5) //rename url_part to avoid conflict
            },
            onlyUpdateToDetach: true
          },
          { headers }
        );
      } catch (err) {
        await this.createError(err);
      }
      item.loading = false;
    },
    copyNews(news, isLocked) {
      const clone = Object.assign({}, news);
      clone.web_release_date = new Date();
      delete clone.id;
      delete clone._id;
      clone._id = "";
      delete clone.newsDate;
      delete clone.web_expire_date;
      delete clone.web_archive_date;
      if (isLocked) {
        //remove closed issue
        delete clone.issue_id;
      }
      for (const key of Object.keys(clone)) {
        if (key.startsWith("appdinx")) {
          delete clone[key];
        }
      }
      clone.released = false;
      this.editedIndex = -1;
      this.editedItem = clone;
      this.editedItem.isNew = true;
      this.editedItem.principal_id = this.currentPrincipal;

      this.$refs.newsEditDialog.fillData(this);
      this.editDialog = true;
    },
    basename(path) {
      return path.split("/").reverse()[0];
    },
    getDeletedDeclinedClass(item) {
      if (item.deleted) {
        return "deleted__news";
      }
      if (item.declined) {
        return "declined__news";
      }
      return "";
    },
    openEmailHtml(item) {
      window.open(
        item.fromExternEmailFile.content.html.url,
        item.fromExternEmailFile.content.title,
        "popup=true,width=600,height=800"
      );
    },
    ...newsHelperVar
  }
};
